export default __webpack_public_path__ + "static/media/logo-pv-topo.50313ca2.png";